import React, { Component } from "react"
import { graphql } from "@apollo/client/react/hoc"
import { Row, Col, Nav, NavItem, NavLink, Container, } from "reactstrap"
import gql from "graphql-tag"

import Loader from "../../Material/Loader"
import OverviewTab from "./GroupDetailTab/OverviewTab"
import withApolloClient from "../../withApolloClient"

import "./GroupDetails.css"

const GroupQuery = gql`
  query group($id: ID!) {
    group(id: $id) {
      id
      name
    }
  }
`

class GroupsDetails extends Component {
    state = {
        activeTab: "overview",
    }

    render() {
        const { group, loading } = this.props
        if (loading) return <Loader />
        if (!group) return null

        return (
            <Container fluid className="group-details-page">
                <div className="group-header">
                    <Row className="align-items-center">
                        <Col md="12">
                            <div className="group-header-title">
                                <div className="group-icon">
                                    <i className="fa fa-universal-access" aria-hidden="true" />
                                </div>

                                <div>
                                    <div className="group-title">
                                        {group.name || "-"}
                                    </div>

                                    <div className="group-subtitle">
                                        Permission Group
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>

                {/* TABS */}
                <Nav className="group-tabs">
                    <NavItem>
                        <NavLink
                            className={this.state.activeTab === "overview" ? "active" : ""}
                            onClick={() => this.setState({ activeTab: "overview" })}
                        >
                            Overview
                        </NavLink>
                    </NavItem>
                </Nav>

                {/* CONTENT */}
                <div className="group-content">
                    {this.state.activeTab === "overview" && (
                        <OverviewTab groupId={group.id} />
                    )}
                </div>
            </Container>
        )
    }
}

export default graphql(GroupQuery, {
    options: props => ({
        fetchPolicy: "network-only",
        notifyOnNetworkStatusChange: true,
        variables: {
            id: props.params.id,
        },
    }),
    props: ({ data }) => ({
        group: data.group,
        loading: data.loading,
    }),
})(withApolloClient(GroupsDetails))
